module.exports = __webpack_public_path__ + "static/digital-lesson-498ad26a368bfe257b7a35021f215669.pdf";